/**
 * AdminBreadcrumbs — automatische breadcrumb-trail met chevron-separators.
 * Op mobiel: scrollt horizontaal indien nodig, toont geen "Backoffice" root.
 */
import React from "react";
import { ChevronRight } from "lucide-react";

export default function AdminBreadcrumbs({ crumbs = [], onNavigate }) {
  if (!crumbs || crumbs.length === 0) return null;
  return (
    <nav
      className="flex items-center gap-1.5 text-sm text-slate-500 overflow-x-auto whitespace-nowrap scrollbar-thin"
      aria-label="Broodkruimels"
      data-testid="admin-breadcrumbs"
    >
      {crumbs.map((c, i) => {
        const isLast = i === crumbs.length - 1;
        const isClickable = !isLast && c.key && onNavigate;
        return (
          <React.Fragment key={`${c.key ?? "root"}-${i}`}>
            {i > 0 && <ChevronRight className="w-3.5 h-3.5 text-slate-300 flex-shrink-0" />}
            {isClickable ? (
              <button
                type="button"
                onClick={() => onNavigate(c.key)}
                className="hover:text-brand-500 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-brand-500/40 rounded px-0.5"
                data-testid={`breadcrumb-${c.key}`}
              >
                {c.label}
              </button>
            ) : (
              <span
                className={
                  isLast
                    ? "text-brand-900 font-semibold cursor-default"
                    : "text-slate-400 cursor-default"
                }
                data-testid={isLast ? "breadcrumb-active" : undefined}
              >
                {c.label}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
